import { useEffect, useState } from 'react';
import { getStripeKycDetails } from '../api/stripeConnectApi';
import { httpStatusCodes } from '../constants/httpStatusCodes';
import { toastMessages } from '../constants/errorMessages';
import { StripeKycDetails } from '../types/interfaces/stripeConnect.interfaces';

type StripeKycRequestError = {
  response?: {
    status?: number;
  };
};

const useStripeKycDetails = (accountId?: number) => {
  const [kycDetails, setKycDetails] = useState<StripeKycDetails | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    if (!accountId) return;

    let isCurrent = true;
    setErrorMessage(null);

    const loadKycDetails = async () => {
      try {
        const { data } = await getStripeKycDetails(accountId);
        if (!isCurrent) return;
        setKycDetails(data ?? null);
        setErrorMessage(null);
      } catch (error) {
        if (!isCurrent) return;

        const requestError = error as StripeKycRequestError;
        if (requestError.response?.status === httpStatusCodes[404]) {
          setKycDetails(null);
          setErrorMessage(null);
          return;
        }

        setErrorMessage(toastMessages.STRIPE_KYC_DETAILS_UNAVAILABLE);
      }
    };

    void loadKycDetails();

    return () => {
      isCurrent = false;
    };
  }, [accountId]);

  return { kycDetails, errorMessage };
};

export default useStripeKycDetails;
